"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

var _react = require("react");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.useResize = void 0;

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

var useResize = function useResize(a, b, c, d, f) {
  var g = (0, _react.useState)(!1),
      h = _slicedToArray(g, 2),
      i = h[0],
      j = h[1],
      k = (0, _react.useState)({
    initX: 0,
    initY: 0,
    initWidth: 0,
    initHeight: 0,
    mouseDownX: 0,
    mouseDownY: 0
  }),
      l = _slicedToArray(k, 2),
      m = l[0],
      n = l[1],
      o = (0, _react.useCallback)(function (f) {
    f.preventDefault(), n({
      initX: a,
      initY: b,
      initWidth: c,
      initHeight: d,
      mouseDownX: f.clientX,
      mouseDownY: f.clientY
    }), j(!0);
  }, [c, d, j, n, a, b]);

  return (0, _react.useEffect)(function () {
    var a = function a(_a) {
      if (i) {
        var b = m.initX,
            c = m.initY,
            d = m.initWidth,
            e = m.mouseDownX,
            g = m.initHeight,
            h = m.mouseDownY,
            j = _a.clientX - e,
            k = _a.clientY - h;
        return f({
          x: b,
          y: c,
          width: d + j,
          height: g + k
        });
      }
    };

    return window.addEventListener("mousemove", a, {
      passive: !0
    }), function () {
      return window.removeEventListener("mousemove", a);
    };
  }, [m, i, f]), (0, _react.useEffect)(function () {
    var a = function a() {
      j(!1);
    };

    return window.addEventListener("mouseup", a), function () {
      return window.removeEventListener("mouseup", a);
    };
  }, [j]), o;
};

exports.useResize = useResize;